import { render, staticRenderFns } from "./TokenInvalid.vue?vue&type=template&id=293f1aad&scoped=true&lang=pug&"
import script from "./TokenInvalid.vue?vue&type=script&lang=ts&"
export * from "./TokenInvalid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293f1aad",
  null
  
)

export default component.exports